import './disable_after_click';
import './slide_toggle';
import './sortable';
import './tooltips';
import './datepickers/legacy/index';
import './datepickers/accessible/index';
